/*
  Girls Know word quiz.
  Each answer scores a word; the most-scored word decides which result is shown.
  Ties fall to whichever word was picked first, so an answer is never ambiguous.
*/
if (!customElements.get('gk-quiz')) {
  customElements.define(
    'gk-quiz',
    class GkQuiz extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-gk-step]'));
        this.result = this.querySelector('[data-gk-result]');
        this.items = Array.from(this.querySelectorAll('[data-gk-result-item]'));
        this.progress = Array.from(this.querySelectorAll('[data-gk-progress] li'));
        if (!this.steps.length || !this.result) return;

        this.picks = [];

        this.addEventListener('click', (event) => {
          const option = event.target.closest('[data-gk-option]');
          if (option && this.contains(option)) {
            this.answer(option.dataset.word || '');
            return;
          }
          if (event.target.closest('[data-gk-retake]')) this.reset();
        });

        this.reset();
      }

      show(index) {
        this.index = index;
        this.steps.forEach((step, i) => step.classList.toggle('is-on', i === index && index < this.steps.length));
        this.result.classList.toggle('is-on', index >= this.steps.length);
        this.progress.forEach((bar, i) => bar.classList.toggle('is-on', i <= index));

        const current = index < this.steps.length ? this.steps[index] : this.result;
        // move focus to the new panel so keyboard and screen readers follow along
        current?.focus?.({ preventScroll: true });
        if (this.dataset.scroll !== 'false') {
          this.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }

      answer(word) {
        if (word) this.picks.push(word);
        const next = this.index + 1;
        // pick the result before revealing the panel, so the right one is there from frame one
        if (next >= this.steps.length) this.decide();
        this.show(next);
      }

      decide() {
        const tally = new Map();
        this.picks.forEach((word) => tally.set(word, (tally.get(word) || 0) + 1));

        let winner = this.picks[0] || '';
        let best = 0;
        // this.picks order breaks ties: the earliest-picked word wins
        this.picks.forEach((word) => {
          const score = tally.get(word) || 0;
          if (score > best) {
            best = score;
            winner = word;
          }
        });

        const match = this.items.find((item) => item.dataset.word === winner) || this.items[0];
        this.items.forEach((item) => item.classList.toggle('is-on', item === match));
        this.dispatchEvent(new CustomEvent('gk:quiz:result', { bubbles: true, detail: { word: winner } }));
      }

      reset() {
        this.picks = [];
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.items.forEach((item, i) => item.classList.toggle('is-on', i === 0));
        this.steps.forEach((step, i) => step.classList.toggle('is-on', i === 0));
        this.result.classList.remove('is-on');
        this.progress.forEach((bar, i) => bar.classList.toggle('is-on', i === 0));
        this.index = 0;
      }
    }
  );
}
